// extracted by mini-css-extract-plugin
module.exports = {"previewLabel":"Header_previewLabel__2TC_C","header":"Header_header__2ri2d","button":"Header_button__2XW_P","disabled":"Header_disabled__2FM0b","active":"Header_active__w8RG7"};